export default "__VITE_ASSET__cbb54d60__"